import { render, staticRenderFns } from "./MosaicoColuna.vue?vue&type=template&id=495d1658&scoped=true"
import script from "./MosaicoColuna.vue?vue&type=script&lang=js"
export * from "./MosaicoColuna.vue?vue&type=script&lang=js"
import style0 from "./MosaicoColuna.vue?vue&type=style&index=0&id=495d1658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d1658",
  null
  
)

export default component.exports